import { useLocation } from 'react-router-dom';
import FolderTable from '../kb-folder-table';
import FolderDetailsCard from './folder-details-card';

function FolderTableOrDetailsCard() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const service = searchParams.get('service');

  if (service === 'G-drive' || service === 'aws') {
    return <FolderDetailsCard />;
  }

  return <FolderTable />;
}

export default FolderTableOrDetailsCard;
